// 組織結構裡的全部家戶（含未指派的）＋路徑：設備庫存〔配對新設備〕的目標挑選器用（GET …/nodes 一層一層翻，org.devices 唯讀可用）。
import type { MyOrg } from '../../lib/planeApi';
import { treeApi, type OrgTreeItem } from '../../lib/orgTreeApi';
import type { PairTarget } from '../devices/PairDialog';

export async function homeTargets(org: MyOrg, max = 2000): Promise<PairTarget[]> {
  const out: PairTarget[] = [];
  const first = await treeApi.children(org);
  const root = first.root?.node_id;
  const queue: { items: OrgTreeItem[]; path: string[]; node?: string; ids: string[] }[] = [{ items: first.items, path: [], ids: root ? [root] : [] }];
  let visited = 0;
  while (queue.length && out.length < max && visited < max) {
    const { items, path, node, ids } = queue.shift()!;
    for (const it of items) {
      if (it.kind === 'home' && it.home_id) out.push({ home_id: it.home_id, label: [...path, it.name].join(' › '), api: org.api, unassigned: it.management_status === 'unassigned', node_id: it.parent_node_id ?? node ?? root, node_path: ids });
      else if (it.kind === 'node' && it.node_id && it.has_children !== false && it.status !== 'archived') {
        visited++;
        queue.push({ items: (await treeApi.children(org, it.node_id)).items, path: [...path, it.name], node: it.node_id, ids: [...ids, it.node_id] });
      }
    }
  }
  return out;
}
